export const home = {
  title: 'Elige un espacio de trabajo',
  empty: 'Sin espacios asignados',
};
